import { Link, makeStyles, tokens } from '@fluentui/react-components';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles({
    steps: {
        margin: 0,
        paddingLeft: tokens.spacingHorizontalXL,
        color: tokens.colorNeutralForeground2,
    },
});

// The order an admin and the user turn the MCP on in Visma My Services.
const activationSteps = [
    { key: 'activationStep1', path: 'subscriptions' },
    { key: 'activationStep2', path: 'users' },
    { key: 'activationStep3', path: 'home' },
];

const isHttpsUrl = (url?: string | null): url is string => {
    try {
        return !!url && new URL(url).protocol === 'https:';
    } catch {
        return false;
    }
};

interface SpirisActivationStepsProps {
    // The configured Visma My Services base URL; the steps show without links unless it is https.
    activationUrl?: string | null;
}

export const SpirisActivationSteps: React.FC<SpirisActivationStepsProps> = ({ activationUrl }) => {
    const styles = useStyles();
    const { t } = useTranslation();

    return (
        <ol className={styles.steps}>
            {activationSteps.map(({ key, path }) => (
                <li key={key}>
                    {t(`spiris.connect.${key}`)}
                    {isHttpsUrl(activationUrl) && (
                        <>
                            {' '}
                            <Link
                                href={new URL(path, activationUrl).href}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid={`spiris-activate-${path}`}
                            >
                                {t('spiris.connect.activationOpen')}
                            </Link>
                        </>
                    )}
                </li>
            ))}
        </ol>
    );
};
